import { useLazyQuery } from '@apollo/client';
import React, { useState } from 'react';

import { Icon, IconMap } from '@flixbus/honeycomb-icons-react';
import {
	LegacyAutocomplete as Autocomplete,
	LegacyAutocompleteInput as AutocompleteInput,
	LegacyAutocompleteOptions as AutocompleteOptions,
} from '@flixbus/honeycomb-react';

import { SEACH_CITIES_WITH_STATIONS_ONLY, SEARCH_CITY_BY_NAME } from './qql/locationSearch';

const DATA_ROUTE = {
	all: 'searchCitiesByName',
	onlyWithStations: 'searchCitiesWithStationsByName',
};

const LocationSearch = ({
	fieldControl,
	resubmit = () => {},
	onReset,
	label = 'Location',
	placeholder = 'e.g. Boston',
	setValue,
	extraClasses = '',
	fieldToReset = 'cityId',
	readOnly = false,
	searchOnlyWithStations = false,
}) => {
	const [getCitiesByName, { loading, error, data }] = useLazyQuery(
		searchOnlyWithStations ? SEACH_CITIES_WITH_STATIONS_ONLY : SEARCH_CITY_BY_NAME
	);
	const [isDebounceTriggered, setDebounceTriggered] = useState(false);

	const onDebounce = (e) => {
		if (!e.target.value) return;
		getCitiesByName({ variables: { cityName: e.target.value } });
		setDebounceTriggered(true);
	};

	const onSelect = (item) => {
		setDebounceTriggered(false);
		setValue(fieldControl.name, item, { shouldDirty: true, shouldValidate: true });
		resubmit();
	};

	const readyToShow = () => {
		const isQueryOk = !loading && !error;
		return !!(isQueryOk && isDebounceTriggered);
	};

	const getData = () => {
		const route = searchOnlyWithStations ? DATA_ROUTE.onlyWithStations : DATA_ROUTE.all;
		const dataToMap = data[route];
		return dataToMap.map((city) => ({
			title: city.name,
			key: city.id,
			timezone: city.timezone,
		}));
	};

	const getOptions = () => {
		return readyToShow() ? getData() : [];
	};

	const checkEmpty = (e) => {
		if (e.target.value === '') {
			// resubmit("cityId");
			if (onReset !== undefined) {
				onReset(fieldToReset);
			}
			if (resubmit === undefined) return;
			resubmit();
		}
	};

	return (
		<Autocomplete
			onDebounce={(e) => onDebounce(e)}
			onSelect={(item) => {
				onSelect(item);
			}}
			onChange={(e) => {
				checkEmpty(e);
			}}
			options={getOptions()}
			value={fieldControl.value.title ? fieldControl.value.title : ''}
			placeholder="e.g. Boston"
			label={label}
			extraClasses={extraClasses}
		>
			<AutocompleteInput
				id="autocomplete-city"
				placeholder={placeholder}
				label={label}
				loading={loading}
				iconLeft={<Icon InlineIcon={IconMap} />}
				type="search"
				disabled={fieldControl.disabled}
				readOnly={readOnly}
			/>
			<AutocompleteOptions label="Lines" optionsToDisplay={5} />
		</Autocomplete>
	);
};

export default LocationSearch;
